import * as Sentry from "@sentry/vue";

export function inicializarSentry(Vue) {

    if (process.env.NODE_ENV === 'dev')
        return;

    Sentry.init({
        Vue,
        dsn: "https://9a6028c26c94bc5ee37c06cf484ebf0e@sentry.digix.com.br/32",
        environment: process.env.NODE_ENV,
        integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        tracePropagationTargets: ["**"]
    });
}

export function configurarUsuarioNoSentry(login) {
    const scope = Sentry.getCurrentScope();
    scope.setUser({ "Login": login });
}


// WEBPACK FOOTER //
// ./src/utils/lib/sentryInit.js